import _Spin from "choerodon-ui/lib/spin";
import { createSpin } from "@hzero-front-ui/core";
import "./css";
export default createSpin(_Spin);